export default [
  {
    path: '/community',
    loader: () => import('@pages/community/index.tsx')
  },

  {
    path: '/doc-view',
    loader: () => import('@pages/doc-view/index.tsx')
  },

  {
    path: '/home',
    loader: () => import('@pages/home/index.tsx')
  },

  {
    path: '/login',
    loader: () => import('@pages/login/index.tsx')
  }
]
